module.exports = __webpack_public_path__ + "static/media/6.8255a62c.jpg";